import * as ng from 'angular';

import { SurveyItemsApiService, XmlValidationResult } from './survey-items-api.service';

export class ValidateSurveyController {
   static $inject = ['session', 'loader', 'surveyItemsApi', 'titleService'];

   severityClasses = {
      Error: 'danger',
      Warn: 'warning'
   };

   validationResults:XmlValidationResult[];
   validationPassed = false;
   error:string;

   constructor(
      private session,
      private loader,
      private surveyItemsApi:SurveyItemsApiService,
      titleService
   ) {
      titleService.setTitle('Survey Item Validation');
   }

   validate(file:File) {
      if (!file) {
         return;
      }

      this.loader.showMessage('Validating survey', 'This may take a few moments...');

      this.surveyItemsApi.validateXmlFile(this.session.getBrand().id, file)
         .finally(() => this.loader.hide())
         .then((results) => {
            this.validationResults = results;
            this.validationPassed = results.length === 0;
            this.error = null;
         }).catch(() => {
            this.validationPassed = false;
            this.error = 'An error has occurred. Please ensure the xml file is properly formatted.';
         });
   }
}

ng.module('e360')
   .controller('ValidateSurveyController', ValidateSurveyController);
